import { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { captureReferral, validReferralCode } from 'src/utils/referral'

/**
 * Removes `?ref=` from the address bar once it's been stored, keeping every other param (e.g. `?code=`).
 * The first page load is captured in index.tsx before render; this also covers in-app links carrying ?ref=.
 */
const ReferralCapture = () => {
    const location = useLocation()
    const history = useHistory()

    useEffect(() => {
        const params = new URLSearchParams(location.search)
        if (!params.has('ref')) return

        const code = validReferralCode(params.get('ref'))
        if (code) captureReferral(code)

        params.delete('ref')
        const search = params.toString()
        history.replace({ ...location, search: search ? `?${search}` : '' })
    }, [location, history])

    return null
}

export default ReferralCapture
